var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14779 11.2643C2.39461 9.99464 2.13085 8.49369 2.40601 7.04331C2.68118 5.59292 3.47636 4.29287 4.64222 3.38728C5.80809 2.48169 7.26445 2.03286 8.73782 2.12506C10.2112 2.21726 11.6002 2.84415 12.6441 3.88802C13.688 4.93189 14.3149 6.32093 14.4071 7.7943C14.4993 9.26768 14.0505 10.724 13.1449 11.8899C12.2393 13.0558 10.9393 13.851 9.48888 14.1261C8.03849 14.4013 6.53754 14.1375 5.26786 13.3844L5.26788 13.3843L3.17415 13.9825C3.08752 14.0073 2.99586 14.0084 2.90864 13.9858C2.82143 13.9632 2.74185 13.9177 2.67815 13.854C2.61445 13.7903 2.56894 13.7107 2.54634 13.6235C2.52374 13.5363 2.52487 13.4446 2.54963 13.358L3.14783 11.2643L3.14779 11.2643Z",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3418 7.15991H10.3832",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3418 9.1806H10.3832",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.3b2c8dfa9ac1567185c010cdb0bf1e85.svg";
export { ForwardRef as ReactComponent };